// File: C:\Users\s-naidu\Desktop\merchant-card\frontend\src\merchant\pages\forms\Form3PaymentHandling.tsx

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import MerchantLayout from "../../components/MerchantLayout";
import { apiGet, apiPut } from "../../api";

type Form3 = {
  // UI field names (keep these)
  monthly_sales: string; // 月間売上高
  monthly_credit_usage: string; // 月間信販利用額
  settlement_ratio: string; // 決済比率（全体%）

  ratio_cash: string; // 現金 %
  ratio_shinpan: string; // 信販 %
  ratio_credit_card: string; // クレジットカード %

  shinpan_contract: string; // ご利用信販会社（有/無）

  // 信販（最大5社）
  shinpan_company_1: string;
  shinpan_customer_fee_1: string;
  shinpan_store_fee_1: string;

  shinpan_company_2: string;
  shinpan_customer_fee_2: string;
  shinpan_store_fee_2: string;

  shinpan_company_3: string;
  shinpan_customer_fee_3: string;
  shinpan_store_fee_3: string;

  shinpan_company_4: string;
  shinpan_customer_fee_4: string;
  shinpan_store_fee_4: string;

  shinpan_company_5: string;
  shinpan_customer_fee_5: string;
  shinpan_store_fee_5: string;

  creditcard_contract: string; // ご利用クレジットカード会社（有/無）

  // クレカ（最大2社）
  creditcard_company_1: string;
  creditcard_customer_fee_1: string;
  creditcard_store_fee_1: string;

  creditcard_company_2: string;
  creditcard_customer_fee_2: string;
  creditcard_store_fee_2: string;

  service_handling: string; // 役務取扱（可/不可）

  is_completed: boolean;
};

const empty: Form3 = {
  monthly_sales: "",
  monthly_credit_usage: "",
  settlement_ratio: "",

  ratio_cash: "",
  ratio_shinpan: "",
  ratio_credit_card: "",

  shinpan_contract: "",

  shinpan_company_1: "",
  shinpan_customer_fee_1: "",
  shinpan_store_fee_1: "",

  shinpan_company_2: "",
  shinpan_customer_fee_2: "",
  shinpan_store_fee_2: "",

  shinpan_company_3: "",
  shinpan_customer_fee_3: "",
  shinpan_store_fee_3: "",

  shinpan_company_4: "",
  shinpan_customer_fee_4: "",
  shinpan_store_fee_4: "",

  shinpan_company_5: "",
  shinpan_customer_fee_5: "",
  shinpan_store_fee_5: "",

  creditcard_contract: "",

  creditcard_company_1: "",
  creditcard_customer_fee_1: "",
  creditcard_store_fee_1: "",

  creditcard_company_2: "",
  creditcard_customer_fee_2: "",
  creditcard_store_fee_2: "",

  service_handling: "",

  is_completed: false,
};

export default function Form3PaymentHandling() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [data, setData] = useState<Form3>(empty);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // ✅ Step③: 「（必須）」が付いている項目だけで判定する
  const canComplete = useMemo(() => {
    return (
      data.monthly_sales.trim() !== "" &&
      data.monthly_credit_usage.trim() !== "" &&
      data.shinpan_contract.trim() !== "" &&
      data.creditcard_contract.trim() !== ""
    );
  }, [data]);

  const statusLabel = canComplete ? "入力済み" : "未完了";
  

  useEffect(() => {
    const run = async () => {
      setError("");
      setSuccess("");

      try {
        const json = await apiGet("/merchant/forms/payment-handling");
        const d = json?.data;

        if (d) {
          setData({
            monthly_sales: d.monthly_sales || "",
            monthly_credit_usage: d.monthly_credit_usage || "",
            settlement_ratio: d.settlement_ratio || "",

            ratio_cash: d.ratio_cash || "",
            ratio_shinpan: d.ratio_shinpan || "",
            ratio_credit_card: d.ratio_credit_card || "",

            shinpan_contract: d.shinpan_contract || "",

            shinpan_company_1: d.shinpan_company_1 || "",
            shinpan_customer_fee_1: d.shinpan_customer_fee_1 || "",
            shinpan_store_fee_1: d.shinpan_store_fee_1 || "",

            shinpan_company_2: d.shinpan_company_2 || "",
            shinpan_customer_fee_2: d.shinpan_customer_fee_2 || "",
            shinpan_store_fee_2: d.shinpan_store_fee_2 || "",

            shinpan_company_3: d.shinpan_company_3 || "",
            shinpan_customer_fee_3: d.shinpan_customer_fee_3 || "",
            shinpan_store_fee_3: d.shinpan_store_fee_3 || "",

            shinpan_company_4: d.shinpan_company_4 || "",
            shinpan_customer_fee_4: d.shinpan_customer_fee_4 || "",
            shinpan_store_fee_4: d.shinpan_store_fee_4 || "",

            shinpan_company_5: d.shinpan_company_5 || "",
            shinpan_customer_fee_5: d.shinpan_customer_fee_5 || "",
            shinpan_store_fee_5: d.shinpan_store_fee_5 || "",

            creditcard_contract: d.creditcard_contract || "",

            creditcard_company_1: d.creditcard_company_1 || "",
            creditcard_customer_fee_1: d.creditcard_customer_fee_1 || "",
            creditcard_store_fee_1: d.creditcard_store_fee_1 || "",

            creditcard_company_2: d.creditcard_company_2 || "",
            creditcard_customer_fee_2: d.creditcard_customer_fee_2 || "",
            creditcard_store_fee_2: d.creditcard_store_fee_2 || "",

            service_handling: d.service_handling || "",

            is_completed: Boolean(d.is_completed),
          });
        } else {
          setData(empty);
        }

        setLoading(false);
      } catch (e: any) {
        setError(
          e?.message ||
            "決済取扱状況の取得に失敗しました。バックエンドが起動しているか確認してください。"
        );
        setLoading(false);
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    const onSave = async (): Promise<boolean> => {
    setError("");
    setSuccess("");
    setSaving(true);

    try {
      const json = await apiPut("/merchant/forms/payment-handling", {
        monthly_sales: data.monthly_sales,
        monthly_credit_usage: data.monthly_credit_usage,
        settlement_ratio: data.settlement_ratio,

        ratio_cash: data.ratio_cash,
        ratio_shinpan: data.ratio_shinpan,
        ratio_credit_card: data.ratio_credit_card,

        shinpan_contract: data.shinpan_contract,

        shinpan_company_1: data.shinpan_company_1,
        shinpan_customer_fee_1: data.shinpan_customer_fee_1,
        shinpan_store_fee_1: data.shinpan_store_fee_1,

        shinpan_company_2: data.shinpan_company_2,
        shinpan_customer_fee_2: data.shinpan_customer_fee_2,
        shinpan_store_fee_2: data.shinpan_store_fee_2,

        shinpan_company_3: data.shinpan_company_3,
        shinpan_customer_fee_3: data.shinpan_customer_fee_3,
        shinpan_store_fee_3: data.shinpan_store_fee_3,

        shinpan_company_4: data.shinpan_company_4,
        shinpan_customer_fee_4: data.shinpan_customer_fee_4,
        shinpan_store_fee_4: data.shinpan_store_fee_4,

        shinpan_company_5: data.shinpan_company_5,
        shinpan_customer_fee_5: data.shinpan_customer_fee_5,
        shinpan_store_fee_5: data.shinpan_store_fee_5,

        creditcard_contract: data.creditcard_contract,

        creditcard_company_1: data.creditcard_company_1,
        creditcard_customer_fee_1: data.creditcard_customer_fee_1,
        creditcard_store_fee_1: data.creditcard_store_fee_1,

        creditcard_company_2: data.creditcard_company_2,
        creditcard_customer_fee_2: data.creditcard_customer_fee_2,
        creditcard_store_fee_2: data.creditcard_store_fee_2,

        service_handling: data.service_handling,

        is_completed: canComplete,
      });

      setData((prev) => ({ ...prev, is_completed: canComplete }));
      const okCompleted = Boolean(json?.is_completed ?? canComplete);
      setSuccess(okCompleted ? "保存しました（入力済み）" : "保存しました（未完了）");
      setSaving(false);
      return true;
    } catch (e: any) {
      setError(e?.message || "保存に失敗しました。バックエンドが起動しているか確認してください。");
      setSaving(false);
      return false;
    }
  };



    const onBack = async () => {
    const ok = await onSave();
    if (!ok) return;
    navigate("/merchant/forms/representative");
  };

  const onNext = async () => {
    const ok = await onSave();
    if (!ok) return;
    navigate("/merchant/forms/products");
  };

  const onList = async () => {
  const ok = await onSave();
  if (!ok) return;
  navigate("/merchant/register");
};




  return (
    <MerchantLayout title="3. 決済取扱状況" active="forms">
      {loading && <div style={{ color: "#475569" }}>読み込み中...</div>}

      {error && (
        <div
          style={{
            marginBottom: 12,
            background: "#fff1f2",
            border: "1px solid #fecdd3",
            color: "#b91c1c",
            padding: "10px 12px",
            borderRadius: 12,
            fontWeight: 800,
          }}
        >
          {error}
        </div>
      )}

      {success && (
        <div
          style={{
            marginBottom: 12,
            background: "#ecfdf5",
            border: "1px solid #bbf7d0",
            color: "#166534",
            padding: "10px 12px",
            borderRadius: 12,
            fontWeight: 900,
          }}
        >
          {success}（いつでも編集できます）
        </div>
      )}

      {!loading && (
        <>
          {/* ✅ Main grid */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
              gap: 20,
              alignItems: "start",
            }}
          >
            <Field label="月間売上高" required>
  <SuffixInput
    value={data.monthly_sales}
    onChange={(value) => setData({ ...data, monthly_sales: value })}
    placeholder="例）500"
    suffix="万円"
  />
</Field>

            <Field label="月間信販利用額" required>
  <SuffixInput
    value={data.monthly_credit_usage}
    onChange={(value) => setData({ ...data, monthly_credit_usage: value })}
    placeholder="例）200"
    suffix="万円"
  />
</Field>

            

           
            <div
  style={{
    gridColumn: "1 / -1",
    border: "1px solid #cbd5e1",
    borderRadius: 14,
    padding: 16,
     background: "#ffffff",
  }}
>
  <div
    style={{
      fontSize: 15,
      fontWeight: 900,
      marginBottom: 12,
      color: "#0f172a",
    }}
  >
    決済比率
  </div>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
      gap: 20,
      alignItems: "start",
    }}
  >
    <Field label="現金">
  <SuffixInput
    value={data.ratio_cash}
    onChange={(value) => setData({ ...data, ratio_cash: value })}
    placeholder="例）40"
    suffix="%"
  />
</Field>

    <Field label="信販">
  <SuffixInput
    value={data.ratio_shinpan}
    onChange={(value) => setData({ ...data, ratio_shinpan: value })}
    placeholder="例）50"
    suffix="%"
  />
</Field>

    <div style={{ gridColumn: "1 / 2" }}>
      <Field label="クレジットカード">
  <SuffixInput
    value={data.ratio_credit_card}
    onChange={(value) => setData({ ...data, ratio_credit_card: value })}
    placeholder="例）10"
    suffix="%"
  />
</Field>
    </div>
  </div>
</div>

            
           
          </div>



          <div style={{ marginTop: 18 }}>
  <Field label="ご利用信販会社" required>
    <select
      style={inputStyle}
      value={data.shinpan_contract}
      onChange={(e) => setData({ ...data, shinpan_contract: e.target.value })}
    >
      <option value="">選択してください</option>
      {["有", "無"].map((o) => (
        <option key={o} value={o}>
          {o}
        </option>
      ))}
    </select>
  </Field>
</div>



          {/* 信販会社（最大5社） */}
<div
  style={{
    marginTop: 20,
    border: "1px solid #e2e8f0",
    borderRadius: 16,
    padding: 16,
    background: "#ffffff",
  }}
>
  <div style={{ fontWeight: 900, marginBottom: 6 }}>
    ご利用信販会社（最大5社）
  </div>

  <div style={{ color: "#64748b", fontSize: 12, marginBottom: 12 }}>
    「信販会社が有」の場合に入力してください（社名・顧客手数料・加盟店手数料）
  </div>

  <CompanyRow
    idx={1}
    company={data.shinpan_company_1}
    customerFee={data.shinpan_customer_fee_1}
    storeFee={data.shinpan_store_fee_1}
    onChange={(c, cf, sf) =>
      setData({
        ...data,
        shinpan_company_1: c,
        shinpan_customer_fee_1: cf,
        shinpan_store_fee_1: sf,
      })
    }
  />

  <CompanyRow
    idx={2}
    company={data.shinpan_company_2}
    customerFee={data.shinpan_customer_fee_2}
    storeFee={data.shinpan_store_fee_2}
    onChange={(c, cf, sf) =>
      setData({
        ...data,
        shinpan_company_2: c,
        shinpan_customer_fee_2: cf,
        shinpan_store_fee_2: sf,
      })
    }
  />

  <CompanyRow
    idx={3}
    company={data.shinpan_company_3}
    customerFee={data.shinpan_customer_fee_3}
    storeFee={data.shinpan_store_fee_3}
    onChange={(c, cf, sf) =>
      setData({
        ...data,
        shinpan_company_3: c,
        shinpan_customer_fee_3: cf,
        shinpan_store_fee_3: sf,
      })
    }
  />

  <CompanyRow
    idx={4}
    company={data.shinpan_company_4}
    customerFee={data.shinpan_customer_fee_4}
    storeFee={data.shinpan_store_fee_4}
    onChange={(c, cf, sf) =>
      setData({
        ...data,
        shinpan_company_4: c,
        shinpan_customer_fee_4: cf,
        shinpan_store_fee_4: sf,
      })
    }
  />

  <CompanyRow
    idx={5}
    company={data.shinpan_company_5}
    customerFee={data.shinpan_customer_fee_5}
    storeFee={data.shinpan_store_fee_5}
    onChange={(c, cf, sf) =>
      setData({
        ...data,
        shinpan_company_5: c,
        shinpan_customer_fee_5: cf,
        shinpan_store_fee_5: sf,
      })
    }
  />
</div>


          <Field label="ご利用クレジットカード会社" required>
  <select
    style={inputStyle}
    value={data.creditcard_contract}
    onChange={(e) => setData({ ...data, creditcard_contract: e.target.value })}
  >
    <option value="">選択してください</option>
    {["有", "無"].map((o) => (
      <option key={o} value={o}>
        {o}
      </option>
    ))}
  </select>
</Field>




<Field label="役務取扱">
              <select
                style={inputStyle}
                value={data.service_handling}
                onChange={(e) => setData({ ...data, service_handling: e.target.value })}
              >
                <option value="">選択してください</option>
                {["可", "不可"].map((o) => (
                  <option key={o} value={o}>
                    {o}
                  </option>
                ))}
              </select>
            </Field>

          

          {/* クレカ会社（最大2社） */}
          <div style={{ marginTop: 18, fontWeight: 900 }}>
            ご利用クレジットカード会社（最大2社）
          </div>
          <div style={{ color: "#64748b", fontSize: 12, marginTop: 6, marginBottom: 10 }}>
            「クレジットカード会社が有」の場合に入力してください（社名・顧客手数料・加盟店手数料）
          </div>

          <CompanyRow
            idx={1}
            company={data.creditcard_company_1}
            customerFee={data.creditcard_customer_fee_1}
            storeFee={data.creditcard_store_fee_1}
            onChange={(c, cf, sf) =>
              setData({
                ...data,
                creditcard_company_1: c,
                creditcard_customer_fee_1: cf,
                creditcard_store_fee_1: sf,
              })
            }
            prefixLabel="クレジットカード"
          />
          <CompanyRow
            idx={2}
            company={data.creditcard_company_2}
            customerFee={data.creditcard_customer_fee_2}
            storeFee={data.creditcard_store_fee_2}
            onChange={(c, cf, sf) =>
              setData({
                ...data,
                creditcard_company_2: c,
                creditcard_customer_fee_2: cf,
                creditcard_store_fee_2: sf,
              })
            }
            prefixLabel="クレジットカード"
          />

          {/* ✅ Step③: only ONE button on the form page */}
                    <div
            style={{
              marginTop: 18,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <button
              onClick={onBack}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "戻る"}
            </button>

            <button
              onClick={onSave}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#1d4ed8",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "保存"}
            </button>

            <button
  onClick={onList}
  disabled={saving}
  style={{
    padding: "12px 16px",
    borderRadius: 12,
    border: "none",
    background: "#64748b",
    color: "#fff",
    fontWeight: 900,
    cursor: saving ? "not-allowed" : "pointer",
    opacity: saving ? 0.7 : 1,
    transition: "background 0.2s ease",
  }}
>
  一覧
</button>

            <button
              onClick={onNext}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "次へ"}
            </button>
          </div>

          <div style={{ marginTop: 10, fontSize: 13, color: "#475569" }}>
            ステータス：{" "}
            <span style={{ fontWeight: 900, color: canComplete ? "#dc2626" : "#0b1f3b" }}>
              {statusLabel}
            </span>
          </div>

          {!canComplete && (
            <div style={{ fontSize: 12, color: "#475569", fontWeight: 800 }}>
              ※ 必須項目が未入力のため「未完了」になります
            </div>
          )}
        </>
      )}
    </MerchantLayout>
  );
}

/** ✅ Match Form1/Form2 required label style */
function Field({
  label,
  required,
  children,
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6, color: "#0f172a" }}>
        {label} {required ? <span style={{ color: "#b91c1c" }}>（必須）</span> : null}
      </div>
      {children}
    </div>
  );
}

/** ✅ input styles same as Form1/Form2 */
const inputStyle: React.CSSProperties = {
  width: "100%",
  height: 44,
  padding: "0 12px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  background: "#fff",
  color: "#0f172a",
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
};



function SuffixInput({
  value,
  onChange,
  placeholder,
  suffix,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  suffix: string;
}) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
      }}
    >
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          ...inputStyle,
          paddingRight: 52,
        }}
      />
      <span
        style={{
          position: "absolute",
          right: 12,
          top: "50%",
          transform: "translateY(-50%)",
          color: "#475569",
          fontSize: 14,
          fontWeight: 700,
          pointerEvents: "none",
          whiteSpace: "nowrap",
        }}
      >
        {suffix}
      </span>
    </div>
  );
}




function CompanyRow({
  idx,
  company,
  customerFee,
  storeFee,
  onChange,
  prefixLabel,
}: {
  idx: number;
  company: string;
  customerFee: string;
  storeFee: string;
  onChange: (company: string, customerFee: string, storeFee: string) => void;
  prefixLabel?: string;
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "minmax(0,2fr) minmax(0,1fr) minmax(0,1fr)",
        gap: 12,
        marginBottom: 10,
        alignItems: "start",
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6, color: "#0f172a" }}>
          {`${prefixLabel ? prefixLabel : "信販"}会社名（${idx}）`}
        </div>
        <input
          value={company}
          placeholder="例）オリコ / ジャックス / アプラス"
          onChange={(e) => onChange(e.target.value, customerFee, storeFee)}
          style={inputStyle}
        />
      </div>

      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6, color: "#0f172a" }}>
  顧客手数料
</div>
<SuffixInput
  value={customerFee}
  placeholder="例）5"
  onChange={(value) => onChange(company, value, storeFee)}
  suffix="%"
/>
      </div>

      <div style={{ minWidth: 0 }}>
       <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6, color: "#0f172a" }}>
  加盟店手数料
</div>
<SuffixInput
  value={storeFee}
  placeholder="例）3"
  onChange={(value) => onChange(company, customerFee, value)}
  suffix="%"
/>
      </div>
    </div>
  );
}
